import React, { ReactNode } from 'react';
import Header from 'containers/SignupPages/Header';
import ActionsButtons from 'containers/SignupPages/ActionsButtons';
import { Box } from '@material-ui/core';
import NotFoundIcon from 'images/page-not-found-icon.svg';
import CheckIcon from 'images/check-icon.svg';

const IsContractFoundResponse = (props: {
  isFound: boolean;
  title: string;
  subTitle: string;
  onClickNext: Function;
  onClickPrevious: Function;
  nextLabel?: string;
  previousLabel?: string;
  children?: ReactNode;
  gridXs?: number;
  gridNextButton?: number;
}) => {
  const {
    isFound,
    title,
    subTitle,
    onClickNext,
    onClickPrevious,
    children,
    nextLabel,
    previousLabel,
    gridXs,
    gridNextButton,
  } = props;
  return (
    <React.Fragment>
      <Box paddingTop={5} minHeight="34vh">
        <Header
          title={title}
          subTitle={subTitle}
          icon={isFound ? CheckIcon : NotFoundIcon}
        />
        {children}
      </Box>
      <ActionsButtons
        previousLabel={previousLabel}
        nextLabel={nextLabel}
        onClickNext={onClickNext}
        onClickPrevious={onClickPrevious}
        gridXs={gridXs}
        gridNextButton={gridNextButton || 4}
      />
    </React.Fragment>
  );
};

export default IsContractFoundResponse;
